import { Route, Switch } from "react-router";
import { AppRouteUi } from "../../../config/appRoute";
import { PageHHAConfigView } from "./pageHHAConfigView";
import { PageHHAConfigEdit } from "./pageHHAConfigEdit";
import { PageHHAConfigAdd } from "./pageHHAConfigAdd";
import { RedirectRoute } from "../../../components/redirectRoute";

export function PageHHAConfig(): JSX.Element {
  return (
    <div className="">
      <Switch>
        <Route path={AppRouteUi.HHAConfig.Root()} exact component={PageHHAConfigView} />
        <Route path={AppRouteUi.HHAConfig.Edit(":id")} exact component={PageHHAConfigEdit} />
        <Route path={AppRouteUi.HHAConfig.Add()} exact component={PageHHAConfigAdd} />
        <RedirectRoute
          from={AppRouteUi.HHAConfig.Root()}
          to={AppRouteUi.HHAConfig.Root()}
          wildcardOpt={{
            defaultTo404Page: true,
          }}
        />
      </Switch>
    </div>
  );
}